import { render, staticRenderFns } from "./Amap.vue?vue&type=template&id=1bdbc64c&scoped=true"
import script from "./Amap.vue?vue&type=script&lang=js"
export * from "./Amap.vue?vue&type=script&lang=js"
import style0 from "./Amap.vue?vue&type=style&index=0&id=1bdbc64c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdbc64c",
  null
  
)

export default component.exports